import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"900\"],\"variable\":\"--font-montserrat\",\"display\":\"block\",\"preload\":false}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["BigBanner"] */ "/app/packages/website/src/components/banners/big-banner/big-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageFooter"] */ "/app/packages/website/src/components/layout/page-footer/page-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderScripts"] */ "/app/packages/website/src/components/layout/page-header/header-scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageHeader"] */ "/app/packages/website/src/components/layout/page-header/page-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/website/src/context/app-providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/colors.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/common/fonts.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/reset.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/global-elements.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/swiper-slider.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/layout/header.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/layout/footer.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/layout/page-header.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/navbar.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/background.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/app-page.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/app-header.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/download-modal.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/uninstall-modal.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/stats.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/share-modal.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/inventory.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/about-content.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/image-slider.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/full-screen-image-slider-modal.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/reviews.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/leave-a-review.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/reviews-modal.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/delete-a-review-modal.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/reviews-slider.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/ratings-stats.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/star-rating.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/progress-ring.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/technical-details.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/remind-me-mobile.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/browse-more-apps.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/pairing.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/tags.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/app-rich-details-info.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/creator-social.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/creator.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/supported-games-modal.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/common/search-input.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/desktop-notice.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/banners-list.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/apps-list.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/search-page.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/search.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/carousel-slider.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/common/big-banner.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/common/error-placeholder.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/breadcrumb.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/download-section.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/login/login.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/website/src/scss/my-account.scss");
